import './partner-logos.scss';
import Swiper, { Navigation, Grid } from 'swiper';
import 'swiper/scss';

class PartnerLogos {
    constructor ($element, options) {
        this.$partnerLogos = $element;
        const defaults = {
            initAttr: 'data-partner-logos'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$partnerLogos = $element;
        this.partnerLogos = null;

        this.resizeHandler = window.resizeHandler;
        this.sliderActive = false;

        this.initialize();
    }

    initialize () {
        this.checkSize();

        window.resizeHandler.customFunctions.push(() => {
            this.checkSize();
        });
    }

    checkSize () {
        if (window.innerWidth < 1024) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else {
            if (this.sliderActive === true) {
                this.destroySlider();
            }
        }
    }

    initSlider () {
        this.partnerLogos = new Swiper(this.$partnerLogos, {
            modules: [Navigation, Grid],
            slidesPerView: 2,
            grid: {
                rows: 4,
                fill: 'row'
            },
            navigation: {
                nextEl: this.$partnerLogos.querySelector('.slider-button-next'),
                prevEl: this.$partnerLogos.querySelector('.slider-button-prev')
            },
            on: {
                afterInit: () => {
                    if (this.$partnerLogos.querySelector('.slider-button-next').classList.contains('swiper-button-disabled') & this.$partnerLogos.querySelector('.slider-button-prev').classList.contains('swiper-button-disabled')) {
                        this.$partnerLogos.querySelector('.partner-logos__slider-navigation').style.display = 'none';
                    } else {
                        this.$partnerLogos.querySelector('.partner-logos__slider-navigation').style.display = 'flex';
                    }
                }
            }
        });

        this.sliderActive = true;
    }

    destroySlider () {
        if (typeof this.partnerLogos !== 'undefined' && this.partnerLogos !== null) {
            this.partnerLogos.destroy();
            this.sliderActive = false;
            this.$partnerLogos.querySelector('.partner-logos__slider-navigation').style.display = 'none';
        }
    }
}

export { PartnerLogos };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$partnerLogos = $context.querySelectorAll('[data-partner-logos="root"]');

        for (let i = 0; i < $$partnerLogos.length; i++) {
            const $partnerLogos = $$partnerLogos[i];

            const partnerLogosAPI = new PartnerLogos($partnerLogos);
            $partnerLogos.API = partnerLogosAPI;
        }
    }
});
